import { forwardRef } from "react";
import styles from "./HeatmapOverlay.module.css";
import { COURT_VIEWBOX, GROUP_COLORS, zones } from "./courtZones.ts";

interface HeatmapOverlayProps {
  className?: string;
  /** Zone IDs that should be highlighted */
  activeZoneIds?: string[];
  /** FG count per zone ID, displayed as overlay text */
  zoneFgCounts?: Record<string, number>;
}

export const HeatmapOverlay = forwardRef<SVGSVGElement, HeatmapOverlayProps>(
  function HeatmapOverlay({ className, activeZoneIds, zoneFgCounts }, ref) {
    const activeSet = new Set(activeZoneIds ?? []);

    return (
      <svg
        ref={ref}
        viewBox={COURT_VIEWBOX}
        className={`${styles.court} ${className ?? ""}`}
        role="img"
        aria-label="Basketball court heatmap"
      >
        {zones.map((zone) => {
          const isActive = activeSet.has(zone.id);
          const groupColor = GROUP_COLORS[zone.group] ?? "#ffffff";
          const fillColor = isActive ? `${groupColor}99` : "rgba(255,255,255,0.03)";
          const fgCount = zoneFgCounts?.[zone.id];

          return (
            <g key={zone.id} data-zone-group={zone.id}>
              <path
                className={`${styles.zone} ${isActive ? styles.zoneActive : ""}`}
                d={zone.path}
                data-zone={zone.id}
                data-group={zone.group}
                fill={fillColor}
              />
              <text className={styles.label} x={zone.labelX} y={zone.labelY}>
                {zone.shortLabel}
              </text>
              {fgCount !== undefined && fgCount > 0 && (
                <text
                  className={styles.fgCount}
                  x={zone.labelX}
                  y={zone.labelY + 10}
                  data-fg-count={zone.id}
                >
                  {fgCount}
                </text>
              )}
            </g>
          );
        })}
      </svg>
    );
  },
);
